import { AxiosInstance } from 'axios'
import { SharedDocumentInfo } from '@dc-shared-web/hooks/api/document'

type SharedDocumentInfoParams = {
  uuid: string | undefined
}

export const fetchSharedDocumentInfo = async (
  apiClient: AxiosInstance,
  params: SharedDocumentInfoParams
) => {
  const { data } = await apiClient.postForm(
    `/ajax/crunches/${params.uuid}/share-info`,
    {
      uuid: params.uuid,
    }
  )

  return {
    ...data.data,
    _activeShareCount: Object.keys(data.data.shares).reduce((acc, key) => {
      return (
        acc +
        (data.data.shares[key].some((e: SharedDocumentInfo) => !e.is_revoked)
          ? 1
          : 0)
      )
    }, 0),
  }
}
